import React from "react";
import { usePlan } from "../../contexts/PlanContext";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowRight, X } from "lucide-react";

export const QuotaAlert = () => {
    const { planData, getUsage } = usePlan();
    const navigate = useNavigate();
    const [dismissed, setDismissed] = React.useState(false);

    if (!planData || dismissed) return null;

    const alerts = [];
    const resources = [
        { key: "users", label: "utilisateurs" },
        { key: "projects", label: "projets" },
    ];

    for (const r of resources) {
        const { current, limit } = getUsage(r.key);
        if (limit === -1 || limit === 0) continue;
        const pct = (current / limit) * 100;
        if (pct >= 100) {
            alerts.push({ ...r, current, limit, pct, level: "critical" });
        } else if (pct >= 80) {
            alerts.push({ ...r, current, limit, pct, level: "warning" });
        }
    }

    if (alerts.length === 0) return null;

    const hasCritical = alerts.some((a) => a.level === "critical");

    return (
        <div
            className={`relative flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm ${
                hasCritical
                    ? "bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400"
                    : "bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 text-amber-700 dark:text-amber-400"
            }`}
            data-testid="quota-alert"
        >
            <AlertTriangle className="w-4 h-4 flex-shrink-0" />
            <div className="flex-1">
                {alerts.map((a, i) => (
                    <span key={a.key}>
                        {i > 0 && " | "}
                        <strong>{a.current}/{a.limit}</strong> {a.label}
                        {a.level === "critical" ? " (limite atteinte)" : " (presque plein)"}
                    </span>
                ))}
            </div>
            <button
                onClick={() => navigate("/settings/subscription")}
                className="flex items-center gap-1 text-xs font-semibold hover:underline flex-shrink-0"
                data-testid="quota-upgrade-link"
            >
                Upgrader <ArrowRight className="w-3 h-3" />
            </button>
            <button
                onClick={() => setDismissed(true)}
                className="p-0.5 hover:bg-black/5 dark:hover:bg-white/5 rounded"
                data-testid="quota-dismiss-btn"
            >
                <X className="w-3.5 h-3.5" />
            </button>
        </div>
    );
};
